// This marker controls recovery UI only. Supabase validates the session and password update.
const STORAGE_KEY = "pm_password_recovery_user";
const initialParams = typeof window === "undefined"
    ? new URLSearchParams()
    : new URLSearchParams(window.location.hash.slice(1));
let awaitingRecovery = initialParams.get("type") === "recovery";
const invitationLink = initialParams.get("type") === "invite";
if (invitationLink) awaitingRecovery = true;
export const recoveryLinkError = initialParams.has("error") || initialParams.has("error_code");
let recoveryUserId = null;
try {
    recoveryUserId = window.sessionStorage.getItem(STORAGE_KEY);
} catch (_) { /* Recovery still works when browser storage is unavailable. */ }

export function trackPasswordRecovery(event, session) {
    if (event === "PASSWORD_RECOVERY" || (event === "SIGNED_IN" && invitationLink && awaitingRecovery)) {
        awaitingRecovery = false;
        recoveryUserId = session?.user?.id || null;
    } else if (event === "SIGNED_OUT") {
        awaitingRecovery = false;
        recoveryUserId = null;
    } else {
        return;
    }
    try {
        if (recoveryUserId) window.sessionStorage.setItem(STORAGE_KEY, recoveryUserId);
        else window.sessionStorage.removeItem(STORAGE_KEY);
    } catch (_) { /* Keep the in-memory marker. */ }
}

export function isPasswordRecoverySession(session) {
    return Boolean(session?.user?.id && session.user.id === recoveryUserId);
}

export function isAwaitingPasswordRecovery() {
    return awaitingRecovery;
}
